import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import page from '../../../smartpak/page';
import authentication from '../../customeraccount/authentication';


function CartSubmitViewmodel (cartItemsViewModelInstance, toggleValidationMessage){
    this.cartItemsViewModel = cartItemsViewModelInstance;
    this.toggleValidationMessage = toggleValidationMessage;
}

CartSubmitViewmodel.prototype.handleSubmit = function (data, event) {
    event.preventDefault();
    const link = event.currentTarget.href; 

    data.cartItemsViewModel.validateAutoShipSupplyItems();

    if (data.cartItemsViewModel.supplyItemsAreAutoShipValid()) {
        data.toggleValidationMessage(false);

        authentication.checkAuthenticatedThenLaunchLoginOrExecuteTask(function() {
                page.redirectToUrl(link);
            },
            {
                redirectURL: link
            }
        );
        return;
    }

    data.toggleValidationMessage(true);
};


export default CartSubmitViewmodel;
